
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";

interface PostUploadActionsProps {
  onCopyLink: (filePath: string, transferId: string) => Promise<void>;
  filePath: string;
  transferId: string;
}

export function PostUploadActions({ onCopyLink, filePath, transferId }: PostUploadActionsProps) {
  return (
    <div className="flex flex-col items-center space-y-4">
      <p className="text-white text-center">
        ¡Archivo subido correctamente!
      </p>
      <Button 
        onClick={() => onCopyLink(filePath, transferId)} 
        variant="outline"
        className="bg-white/90 hover:bg-white transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
      >
        <Copy className="mr-2 h-4 w-4" />
        Copiar enlace de descarga
      </Button>
    </div>
  );
}
